import { ssoApi } from "@sso/apis";
import { ApiMethodKeys, notificationsMsgs, SnackbarKeys } from "@sso/constant";
import { logOutUser, updateProfilePicture } from "@sso/store/slices/auth";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { UserForm } from "@sso/types";

import { Endpoints } from "../endpoints";

export const accountApi = ssoApi.injectEndpoints({
  endpoints: builder => ({
    uploadProfilePicture: builder.mutation<void, File>({
      query: picture => {
        const data = new FormData();
        data.append("pictureFile", picture);
        return { url: `${Endpoints.ACCOUNT}/UploadPicture`, method: ApiMethodKeys.POST, data };
      },
      onQueryStarted(picture, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(updateProfilePicture(URL.createObjectURL(picture as unknown as Blob)));
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.UPLOAD_PROFILE_PICTURE }));
        });
      },
    }),
    deleteProfilePicture: builder.mutation<void, void>({
      query: () => ({ url: `${Endpoints.ACCOUNT}/DeleteProfilePicture`, method: ApiMethodKeys.DELETE }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(updateProfilePicture(""));
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.REMOVE_PROFILE_PICTURE }));
        });
      },
    }),
    editProfile: builder.mutation<void, Partial<UserForm>>({
      query: data => ({ url: `${Endpoints.ACCOUNT}/Update`, method: ApiMethodKeys.PUT, data }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(logOutUser());
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.UPDATE_PROFILE }));
        });
      },
    }),
  }),
});

export const { useUploadProfilePictureMutation, useDeleteProfilePictureMutation, useEditProfileMutation } = accountApi;
